import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import StartImage from 'svg-react-loader?name=StartImage!./images/start.svg';

import './start.scss';

@inject('appStore', 'store', 'routerStore')
@observer
export class StartComponent extends Component {
    onNext(e) {
        const { history } = this.props.routerStore;
        history.push({ pathname: '/gettingstarted/homedetails', state: { transition: 'forward' } });
    }

    render() {
        const { store } = this.props,
            { page } = store;

        return (
            <section className='ht-page ht-start'>
                <div className='ht-start-wrapper'>

                    <div className='ht-start-content'>
                        <Helmet>
                            <title>{page.StartTitle}</title>
                        </Helmet>
                        <h2 className='ht-start-title'>
                            {page.StartTitle}
                        </h2>
                        <div className='ht-start-intro'
                            dangerouslySetInnerHTML={{ __html: page.StartContent }}
                        />
                        <div className='ht-start-image'>
                            <StartImage/>
                        </div>

                        <button
                            className='ht-button ht-button--start'
                            id='ht-start'
                            onClick={e => this.onNext(e)}
                        >
                            Start
                        </button>
                    </div>
                </div>
            </section>
        );
    }
}
